module.exports = __webpack_public_path__ + "media/images/athletes/2799-b5659b90f3c7a90179a18c81e568874f.png";